import Container from "@mui/material/Container";
import { AppBar, Box, CardContent, Link, Stack, Typography } from "@mui/material";
const Footer = () => {
  return (
    <>
      <AppBar position="relative" sx={{ backgroundColor: "white" }}>
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
          }}
        >
          {/* HTML Sitemap — crawlable navigation links */}
          <Box component="nav" aria-label="Site navigation" sx={{ mb: 1 }}>
            <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center">
              <Link href="/" sx={{ color: "#20141e", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>Home</Link>
              <Link href="/menu" sx={{ color: "#20141e", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>Menu & Order Online</Link>
              <Link href="/catering" sx={{ color: "#20141e", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>Catering</Link>
              <Link href="/contact" sx={{ color: "#20141e", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>Contact</Link>
              <Link href="/franchise" sx={{ color: "#20141e", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>Franchise</Link>
            </Stack>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: "white",
              color: "black",
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography component="div" variant="subtitle1">
                Bagara's © {new Date().getFullYear()} . All rights reserved.
              </Typography>
            </CardContent>
          </Box>
        </Container>
      </AppBar>
    </>
  );
};

export default Footer;
